import React, { useState, useEffect } from 'react';
import './Header.css'

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    closeMobileMenu(); // Close mobile menu when navigating
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
      )}
      
      <div className="container">
        <div className="header-content">
          <div className="logo">
          <img src="/glucoicon.png" alt="Logo" />
            <h2>GlucoPlanner</h2>
          </div>
          {/* Mobile Menu Button */}
          <button 
            className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Desktop Navigation */}
          <nav className="nav desktop-nav">
            <ul className="nav-list">
              <li><button onClick={() => scrollToSection('hero')} className="nav-link">Home</button></li>
              <li><button onClick={() => scrollToSection('features')} className="nav-link">Features</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button></li>
              <li>
                <button
                  onClick={() => window.open('https://gluco-planner.smartclinicpk.com/', '_blank')}
                  className="nav-link nav-button"
                >
                  Use On Web
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const link = document.createElement('a');
                    link.href = '/GlucoPlannerNew.apk';
                    link.download = 'GlucoPlannerNew.apk';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    closeMobileMenu();
                  }}
                  className="nav-link nav-button download-btn"
                >
                  Download App
                </button>
              </li>
            </ul>
          </nav>

          {/* Mobile Navigation */}
          <nav className={`nav mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
            <ul className="mobile-nav-list">
              <li><button onClick={() => scrollToSection('hero')} className="mobile-nav-link">Home</button></li>
              <li><button onClick={() => scrollToSection('features')} className="mobile-nav-link">Features</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="mobile-nav-link">Contact</button></li>
              <li>
                <button
                  onClick={() => {
                    window.open('https://gluco-planner.smartclinicpk.com/', '_blank');
                    closeMobileMenu();
                  }}
                  className="mobile-nav-link mobile-nav-button"
                >
                  Use On Web
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const link = document.createElement('a');
                    link.href = '/GlucoPlannerNew.apk';
                    link.download = 'GlucoPlannerNew.apk';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    closeMobileMenu();
                  }}
                  className="mobile-nav-link mobile-nav-button download-btn"
                >
                  Download App
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
